module.exports = __webpack_public_path__ + "img/KPI.2be3edf0.svg";